"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.passwordsMatchError = exports.anonError = exports.notAnonError = undefined;

var _selectors = require("../../selectors");

var _selectors2 = _interopRequireDefault(_selectors);

var _reselect = require("reselect");

var _form = require("../util/form");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notAnonError = exports.notAnonError = (0, _reselect.createSelector)(_selectors2.default.auth.isAnonymous, function (isAnon) {
  return isAnon ? "notanonymous" : null;
});
var anonError = exports.anonError = (0, _reselect.createSelector)(_selectors2.default.auth.isAnonymous, function (isAnon) {
  return isAnon ? null : "anonymous";
});
var passwordsMatchError = exports.passwordsMatchError = (0, _reselect.createSelector)((0, _form.propname)("password"), (0, _form.propname)("password2"), function (p1, p2) {
  return p1 && p2 && p1 !== p2 ? "passwordmatch" : null;
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb250YWluZXJzL2F1dGgtc2lnbmluL3V0aWwuanMiXSwibmFtZXMiOlsibm90QW5vbkVycm9yIiwiYXV0aCIsImlzQW5vbnltb3VzIiwiaXNBbm9uIiwiYW5vbkVycm9yIiwicGFzc3dvcmRzTWF0Y2hFcnJvciIsInAxIiwicDIiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7OztBQUNBOztBQUNBOzs7O0FBRU8sSUFBTUEsc0NBQWUsOEJBQzFCLG9CQUFFQyxJQUFGLENBQU9DLFdBRG1CLEVBRTFCO0FBQUEsU0FBV0MsU0FBUyxjQUFULEdBQTBCLElBQXJDO0FBQUEsQ0FGMEIsQ0FBckI7QUFJQSxJQUFNQyxnQ0FBWSw4QkFDdkIsb0JBQUVILElBQUYsQ0FBT0MsV0FEZ0IsRUFFdkI7QUFBQSxTQUFXQyxTQUFTLElBQVQsR0FBZ0IsV0FBM0I7QUFBQSxDQUZ1QixDQUFsQjtBQUlBLElBQU1FLG9EQUFzQiw4QkFDakMsb0JBQVMsVUFBVCxDQURpQyxFQUVqQyxvQkFBUyxXQUFULENBRmlDLEVBR2pDLFVBQUNDLEVBQUQsRUFBS0MsRUFBTDtBQUFBLFNBQWFELE1BQU1DLEVBQU4sSUFBWUQsT0FBT0MsRUFBbkIsR0FBd0IsZUFBeEIsR0FBMEMsSUFBdkQ7QUFBQSxDQUhpQyxDQUE1QiIsImZpbGUiOiJ1dGlsLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCBSIGZyb20gXCIuLi8uLi9zZWxlY3RvcnNcIlxuaW1wb3J0IHtjcmVhdGVTZWxlY3Rvcn0gZnJvbSBcInJlc2VsZWN0XCJcbmltcG9ydCB7cHJvcG5hbWV9IGZyb20gXCIuLi91dGlsL2Zvcm1cIlxuXG5leHBvcnQgY29uc3Qgbm90QW5vbkVycm9yID0gY3JlYXRlU2VsZWN0b3IoXG4gIFIuYXV0aC5pc0Fub255bW91cyxcbiAgaXNBbm9uID0+IChpc0Fub24gPyBcIm5vdGFub255bW91c1wiIDogbnVsbCksXG4pXG5leHBvcnQgY29uc3QgYW5vbkVycm9yID0gY3JlYXRlU2VsZWN0b3IoXG4gIFIuYXV0aC5pc0Fub255bW91cyxcbiAgaXNBbm9uID0+IChpc0Fub24gPyBudWxsIDogXCJhbm9ueW1vdXNcIiksXG4pXG5leHBvcnQgY29uc3QgcGFzc3dvcmRzTWF0Y2hFcnJvciA9IGNyZWF0ZVNlbGVjdG9yKFxuICBwcm9wbmFtZShcInBhc3N3b3JkXCIpLFxuICBwcm9wbmFtZShcInBhc3N3b3JkMlwiKSxcbiAgKHAxLCBwMikgPT4gKHAxICYmIHAyICYmIHAxICE9PSBwMiA/IFwicGFzc3dvcmRtYXRjaFwiIDogbnVsbCksXG4pXG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../core/lib/containers/auth-signin/util.js
// module id = 160
// module chunks = 0